import { TopBarSecondaryActionsSlotPlacement as BasicTopBarSecondaryActionsSlotPlacement } from '@wix/extensions-slots-host';
import { withEditorSlotsState } from '../withEditorSlotsState';

export const TopBarSecondaryActionsSlotPlacement = withEditorSlotsState(
  BasicTopBarSecondaryActionsSlotPlacement,
);
